import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { NurseAssessmentService } from 'src/app/services/NurseAssessmentService';
import { NurseAssessmentModel } from 'src/app/models/NurseAssessmentModel';
import { Router } from '@angular/router';
import { NursingAssessmentEntryComponent } from '../nursing-assessment-entry/nursing-assessment-entry.component';


@Component({
  selector: 'app-nursing-assessment-tab',
  templateUrl: './nursing-assessment-tab.component.html',
  styleUrls: ['./nursing-assessment-tab.component.css']
})
export class NursingAssessmentTabComponent implements OnInit {

Patientcode = '';
Patientname = '';
visitdate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
wk_Bold = 'normal'
patientConsent = false;
wk_color = 'rgb(159, 0, 0)';

nurseassesseList :NurseAssessmentModel[]=[];
constructor( public storage: LocalStorageService,
               public nurseassessmentService : NurseAssessmentService,
               public nursassessment : NurseAssessmentModel,
               private dialogref: MatDialog,
               private router: Router
  ) { }

  ngOnInit(): void {

    this.Patientcode = this.storage.retrieve('stgPatientCode');
    this.Patientname = this.storage.retrieve('stgPatientName');
    this.visitdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.RetriveNursing();
  }
RetriveNursing(){
  this.nurseassesseList = [];
   this.nurseassessmentService.getNurseAssessmentLookup(this.Patientcode).subscribe((data: NurseAssessmentModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.nurseassesseList[i] = data[i];
        if (this.nurseassesseList[i].paconsent == 'True' ){this.patientConsent = true;this.wk_color = 'rgb(0, 134, 40)'}

        this.nurseassesseList[i].visitdate =formatDate(data[i].visitdate, 'yyyy-MM-dd', 'en')
        if( this.nurseassesseList[i].visitdate == this.visitdate) {this.nurseassesseList[i].visitlocation = 'bold'}else{this.nurseassesseList[i].visitlocation ='normal'}
      }
    })
}
  NursingEntry(){

           const dialogRef = this.dialogref.open(NursingAssessmentEntryComponent,
             {
               data: {
                 dataKey: this.nursassessment,
                 patientid : this.Patientcode,
                 patientname : this.Patientname,
                 nursedate : formatDate(new Date(), 'yyyy-MM-dd', 'en')

               },
               width: '90vw',
               height: '40vw',
             });
             dialogRef.afterClosed().subscribe(result => {
              // Refresh the same route
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate(['/DoctorObservationTab'], {
                  queryParams: {
                    patientid: this.Patientcode,
                    patientname: this.Patientname
                  }
                });
              });
            });

           const dialogSubmitSubscription =
             dialogRef.componentInstance.submitClicked.subscribe(result => {

             //  this.RetriveNurseAssessment()
               dialogSubmitSubscription.unsubscribe();
             });
  }
}
